module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"interactionDetails":"Interaction Details","copy":"Copy {fieldName} to your clipboard.","copySuccess":"{label} was copied successfully to your clipboard."},"es":{"interactionDetails":"Detalles de la interacción","copy":"Copiar {fieldName} al portapapeles.","copySuccess":"Se copió ${label} correctamente al portapapeles."}}')
  delete Component.options._Ctor
}
